import {useInjex} from '@injex/react-plugin';

export default function useManager<T>(moduleName: string): T {
    const [inject] = useInjex();
    return inject<T>(moduleName);
}
